import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { DESELECT_POST_MALONE_SAVED_TEMPLATE_MUTATION } from './deselectPostMaloneSavedTemplate.mutation';
import {
  DeselectPostMaloneSavedTemplateMutation,
  DeselectPostMaloneSavedTemplateMutationVariables
} from './__generated__/DeselectPostMaloneSavedTemplateMutation';

export const useDeselectPostMaloneSavedTemplate = () => {
  return useMutation<DeselectPostMaloneSavedTemplateMutation, DeselectPostMaloneSavedTemplateMutationVariables>(
    DESELECT_POST_MALONE_SAVED_TEMPLATE_MUTATION,
    { client: kmsClient }
  );
};
